import { Fragment } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

export function ViewRoutePath({ routePath }: { routePath: string }) {
	return (
		<Typography variant="caption" color="text.secondary">
			Path:{' '}
			<Box component="code" sx={{ color: 'primary.main', bgcolor: 'action.hover', borderRadius: 0.5, px: 0.5 }}>
				{routePath.split('/').map((segment, index) => (
					<Fragment key={index}>
						{index > 0 && '/'}
						{segment.startsWith(':') ? (
							<Tooltip title="Requires a route parameter. Open from a parent listing, or confirm to preview without values.">
								<Box
									component="span"
									aria-label="Requires route parameters"
									sx={{ color: 'warning.main', bgcolor: 'action.selected', fontWeight: 'fontWeightBold', borderRadius: 0.5, px: 0.25 }}
								>
									{segment}
								</Box>
							</Tooltip>
						) : (
							segment
						)}
					</Fragment>
				))}
			</Box>
		</Typography>
	);
}
